import { auth, SchemaResponse } from "@/modules/api/axios"
import { Notification } from "@/modules/types"
import { PagingSchema } from "@/modules/types/common/schema"

const paramsSerializer = (params: Record<string, any>): string => {
  return Object.entries(params)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        // Xử lý mảng: tạo chuỗi `type=NEW_CAMPAIGN&type=CREATE_DRAFT`
        return value.map((v) => `${key}=${encodeURIComponent(v)}`).join("&")
      }
      return `${key}=${encodeURIComponent(value)}`
    })
    .join("&")
}

export const fetchAllNotifications = async ({
  nextPageToken,
  filter,
  limit
}: {
  nextPageToken?: string
  filter?: string
  limit?: number
}) => {
  let params: any = {
    order: "DESC",
    sortBy: "createdAt",
    limit: limit || 20
  }

  if (nextPageToken) {
    params = { ...params, nextPageToken }
  }

  let url = "v1/notifications/list?"
  if (filter) {
    url = `notifications/${filter}/list?`
  }
  const queryString = paramsSerializer(params)
  return await auth.get<SchemaResponse<PagingSchema<Notification>>>(url + queryString)
}

export const fetchImportantNotifications = async ({
  nextPageToken,
  take
}: {
  nextPageToken?: string
  take: number
}) => {
  let params: any = {
    limit: take,
    order: "DESC",
    sortBy: "createdAt"
  }

  if (nextPageToken) {
    params = { ...params, nextPageToken }
  }

  const url = "/notifications/important/list?"
  const queryString = paramsSerializer(params)
  return await auth.get<SchemaResponse<PagingSchema<Notification>>>(url + queryString)
}

export const fetchFinancialNotifications = async ({
  nextPageToken,
  take
}: {
  nextPageToken?: string
  take: number
}) => {
  let params: any = {
    limit: take,
    order: "DESC",
    sortBy: "createdAt"
  }

  if (nextPageToken) {
    params = { ...params, nextPageToken }
  }

  const url = "/notifications/financial/list?"
  const queryString = paramsSerializer(params)
  return await auth.get<SchemaResponse<PagingSchema<Notification>>>(url + queryString)
}

export type UnreadCountResponse = {
  totalUnreadImportant: number
  totalUnreadFinancial: number
  totalUnreadNewCampaign: number
}

export const fetchUnreadCount = async () => {
  return await auth.get<SchemaResponse<UnreadCountResponse>>("/notifications/unread/count")
}


export const readAllNotification = async () => {
  return await auth.post<SchemaResponse<UnreadCountResponse>>(
    "/notifications/read-all-notifications-unread"
  )
}
